<template>
  <div class="contactTypes">
    <VSkeletonShimmer v-show="isScreenLoading" />

    <div class="contactTypes__summary" v-show="!isScreenLoading">
      <div class="contactTypes__icon">
        <UserSvg />
      </div>

      <div class="contactTypes__message">
        <span> Selecione por onde deseja receber o código de validação: </span>
      </div>
    </div>

    <ContactTypesActions
      class="contactTypes__actions"
      v-show="!isScreenLoading"
      @run-select-contact-flow="runSelectContactFlow"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ContactTypesActions from '@/views/validationPatient/contactTypes/partials/ContactTypesActions.partial.vue';
import { dataLayersMixin } from '@/utils/mixins';
import datalayerErrorMessage from '@/utils/helpers/message/datalayerErrorMessage.js';

import { HAS_NO_ANY_CONTACT_NUMBER } from '@/utils/constants/datalayerMessage.constants';

export default {
  name: 'ContactTypes',
  components: {
    ContactTypesActions,
  },
  mixins: [dataLayersMixin],

  data() {
    return {
      isScreenLoading: true,
    };
  },

  computed: {
    ...mapState({
      maskedContacts: ({ mdm }) => mdm.data.maskedContacts,
      mdmPatientId: ({ mdm }) => mdm.data.id,
    }),
    ...mapGetters({
      isMobileService: 'isMobileService',
      isScheduledAdmission: 'global/isScheduledAdmission',
    }),

    hasAnyContact() {
      const listOfPhones = this.maskedContacts?.mobilePhoneList;
      const listOfEmails = this.maskedContacts?.emailList;

      const hasAnyContact = listOfPhones?.length || listOfEmails?.length;

      return hasAnyContact;
    },

    failScenarioNextRoute() {
      return this.isMobileService
        ? 'irregular_phone_number_mobile_service'
        : 'irregular_phone_number';
    },
  },

  methods: {
    ...mapActions(['global/setHourAdmissionWithoutScheduling', 'getMdmContactListById']),

    async setUpContactTypeView() {
      await this.getContactList();
      this.toggleScreenLoading();

      if (!this.hasAnyContact) {
        this.goNextStep(
          this.failScenarioNextRoute,
          datalayerErrorMessage('setUpContactTypeView', HAS_NO_ANY_CONTACT_NUMBER),
        );
      }
    },

    async getContactList() {
      await this.getMdmContactListById(this.mdmPatientId).catch(() => {
        this.goNextStep(this.failScenarioNextRoute);
      });
    },

    toggleScreenLoading() {
      setTimeout(() => {
        this.isScreenLoading = !this.isScreenLoading;
      }, 1000);
    },

    runSelectContactFlow() {
      this.goNextStep('patient_validation_select_contact');
    },
  },

  created() {
    if (!this.hasAnyContact) {
      this.setUpContactTypeView();
    }
    if (!this.isScheduledAdmission) {
      this['global/setHourAdmissionWithoutScheduling']();
    }
    this.mostCommonPagesAnalytics({});
  },
};
</script>

<style lang="scss" scoped>
.contactTypes {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 8px 8px;
  width: 100%;

  &__summary {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 110px;
    width: 100%;
  }

  &__icon {
    align-items: center;
    background-color: var(--color-primary-lighten-4);
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    height: 72px;
    justify-content: center;
    margin-bottom: 16px;
    width: 72px;

    svg {
      height: 32px;

      path {
        fill: var(--color-primary);
      }
    }
  }

  &__message {
    display: flex;
    justify-content: center;
    line-height: 1.4;
    width: 100%;

    & span {
      max-width: 290px;
    }
  }
}
</style>
